document.addEventListener('DOMContentLoaded', function() {
  const jsFlickity = document.querySelectorAll('.js-flickity');

  // Custom fulscreen icon

  var pathDirections = {
    view: {
      viewBox: "0 0 15 15",
      path: [
        'M6.16797 3V7',
        'M8.28125 5L4.05936 5',
        'M9.33984 9L13.5617 13',
        'M6.17188 0.5C8.83612 0.5 10.9492 2.53981 10.9492 5C10.9492 7.46019 8.83612 9.5 6.17188 9.5C3.50764 9.49999 1.39453 7.46018 1.39453 5C1.39453 2.53982 3.50764 0.500009 6.17188 0.5Z'
      ]
    },
    exit: {
      viewBox: "0 0 24 24",
      path: [
        'M6 18 17.94 6M18 18 6.06 6',
      ]
    }
  };

  var svgURI = 'http://www.w3.org/2000/svg';
  
  if (Flickity && Flickity.FullscreenButton) {
    Flickity.FullscreenButton.prototype.createIcon = function() {
      var svg = document.createElementNS( svgURI, 'svg');
      svg.setAttribute( 'class', 'flickity-button-icon' );
      svg.setAttribute( 'fill', 'none' );
      // path & direction
      var direction = pathDirections[ this.name ];
      svg.setAttribute( 'viewBox', direction.viewBox || '0 0 15 15' );
      if (Array.isArray(direction.path)) {
        direction.path.forEach(function(d) {
          var path = document.createElementNS(svgURI, 'path');
          path.setAttribute('d', d);
          path.setAttribute('stroke', 'currentColor');
          path.setAttribute('stroke-line-cap', 'round');
          svg.appendChild( path );
        });
      } else {
        var path = document.createElementNS(svgURI, 'path');
        path.setAttribute( 'd', direction );
        // put it together
        svg.appendChild( path );
      }
      this.element.appendChild( svg );
    };
  }

  // Handle trackpad swipes
  function addTrackpadSwipeSupport(flkty, carousel) {
      let isScrolling = false;
      let scrollTimeout;
      let deltaX = 0;
      let deltaY = 0;
      
      carousel.addEventListener('wheel', function(e) {
          // Accumulate deltas
          deltaX += e.deltaX;
          deltaY += e.deltaY;
          
          // Clear previous timeout
          clearTimeout(scrollTimeout);
          
          if (!isScrolling) {
              isScrolling = true;
          }
          
          // Set timeout to detect when scrolling stops
          scrollTimeout = setTimeout(function() {
              isScrolling = false;
              
              // Determine swipe direction and threshold
              const threshold = 25; // Adjust sensitivity
              
              // Only handle horizontal swipes if horizontal movement is dominant
              if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > threshold) {
                  // This was primarily horizontal movement - handle carousel navigation
                  if (deltaX > threshold) {
                      flkty.next(); // Swipe left -> next slide
                  } else if (deltaX < -threshold) {
                      flkty.previous(); // Swipe right -> previous slide
                  }
              }
              
              // Reset deltas
              deltaX = 0;
              deltaY = 0;
          }, 50); // Slightly increased timing for better detection
          
          // Only prevent default if this is primarily horizontal movement
          // Allow vertical scrolling to continue normally
          if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
              e.preventDefault();
          }
          
      }, { passive: false });
  }

  jsFlickity.forEach(function(carousel) {

    const parent = carousel.parentElement;
    const noNav = carousel.classList.contains('no-navigation');
    const fullScreen = carousel.classList.contains('fullscreen');
    
     // Initialize Flickity
    const options = {
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      prevNextButtons: false,
      wrapAround: true,
      adaptiveHeight: true,
      imagesLoaded: true,
      draggable: true,
      dragThreshold: 1,
      // friction: .5
      selectedAttraction: 0.2,
      friction: 0.8
    };

    if (fullScreen) {
      // Fullscreen carousel
      options.fullscreen = true;
      options.prevNextButtons = true;
      options.pageDots = true;
      options.cellAlign = 'center';
      options.adaptiveHeight = false;
    }

    let flkty = new Flickity(carousel, options);
    
    addTrackpadSwipeSupport(flkty, carousel);

    if (noNav === false) {
      // Custom navigation buttons
      parent.querySelector('.carousel-nav-button.previous').addEventListener('click', function() {
        flkty.previous();
      });
      
      parent.querySelector('.carousel-nav-button.next').addEventListener('click', function() {
        flkty.next();
      });
    }

    // flkty.reloadCells();
    // flkty.resize();
    // flkty.destroy();

    window.addEventListener('load', function() {
        flkty.resize();
    });

     window.addEventListener('resize', function() {
        flkty.resize();
    });

    // carousel cell hover effect
    document.querySelectorAll('.product__carousel-cell, .collection__showcase-cell').forEach(cell => {
      if (cell) {
        cell.addEventListener('mouseleave', function() {
          if (cell.classList.contains('selecting')) cell.classList.remove('selecting');
        });
      }
    })

    // play video
    let playVid = document.querySelectorAll('.play-video');
    playVid.forEach(btn => {
      btn.addEventListener('click', function(e) {
          const target = e.currentTarget;
          const parent = target.parentElement.parentElement;
          const vidParent = parent.querySelector('.video__container');
          const vidThumbnail = parent.querySelector('.video__thumbnail');
          const allVideos = document.querySelectorAll('video');
          const video = vidParent.querySelector('video');
          allVideos.forEach(vid => {
            vid.pause();
            vid.currentTime = 0;
          })
          vidParent.classList.remove('hidden');
          vidThumbnail.classList.add('invisible');
          video.play();
      });
    });

  });

  window.addEventListener('load', function() {
    initMiniCart();

    subscribe(PUB_SUB_EVENTS.cartUpdate, initMiniCart);
    subscribe(PUB_SUB_EVENTS.cartShow, initMiniCart);
});

  function initMiniCart() {
  if (firstCartProdId) {
      const firstProdId = firstCartProdId;

      // Shipping Bar
      // const remainingShipAmt = document.getElementById('remainingAmount');
      // remainingShipAmt.innerHTML = Shopify.formatMoney(remainingShipAmt.textContent * Shopify.currency.rate);

      fetch(`${window.Shopify.routes.root}recommendations/products.json?product_id=${firstProdId}&limit=8`)
      .then(data => data.json())
      .then(data => {
          console.log(data);
          let rawProducts = data.products;
          let products = rawProducts
              .map(value => ({ value, sort: Math.random() }))
              .sort((a, b) => a.sort - b.sort)
              .map(({ value }) => value)
          const relatedDiv = document.querySelectorAll('#s--minicart__recommended .minicart-carousel');
          relatedDiv.forEach(div => {
            // const relatedCarousel = div.querySelector('.flickity-slider')
            // if (relatedCarousel) {
            //   relatedCarousel.innerHTML = '';
            // } else {
            //   div.innerHTML = '';
            // }

            const parent = div.parentElement;
            const options = {
              cellAlign: 'left',
              contain: true,
              pageDots: false,
              prevNextButtons: false,
              wrapAround: true,
              adaptiveHeight: false,
              imagesLoaded: true,
              groupCells: false,
              draggable: true,
              percentPosition: true,
            };
            let relFlkty = new Flickity(div, options); 

            parent.querySelector('.loading__spinner-container').classList.add('hidden');

            relFlkty.remove(document.querySelector('.sl-1'));
            relFlkty.remove(document.querySelector('.sl-2'));
            relFlkty.remove(document.querySelector('.sl-3'));
            // div.innerHTML = '';

            let newCell = document.createElement('div');
            newCell.className = 'carousel-cell';
            if (products) {
              products.forEach(prod => {
                const relatedCell = `
                  <div class="product-card">
                    <div class="product-image-container">
                      <img class="product-image" src="${prod.variants[0].featured_image ? prod.variants[0].featured_image.src : prod.featured_image }" alt="${prod.title}" loading="lazy" data-bstr-initd="true">
                    </div>
                    <div class="product-info">
                      <h3 class="product-title">
                        <a href="${prod.url}" title="View product">
                            <span>${prod.title}</span> 
                          </a>
                        </h3>
                        <product-info data-section="CartDrawer" data-product-id="8594769150177" data-update-url="false" data-url="${prod.url}">
                          <product-form data-section-id="template--19641491259617__product_carousel_47Dmt8-0">
                            <form method="post" action="/cart/add" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
                              <input type="hidden" name="form_type" value="product">
                              <input type="hidden" name="utf8" value="✓">
                              <input type="hidden" name="id" value="${prod.variants[0].id}" class="product-variant-id" bss-b2b-product-trigger-added="true">
                              <button class="carousel-atc" type="submit" name="add">
                                <span>ADD TO CART | <span class="product-price">${prod.price_varies ? Shopify.formatMoney(prod.price_min) + '-' + Shopify.formatMoney(prod.price_max) : Shopify.formatMoney(prod.price)}</span></span>
                                 <span class="sold-out-message hidden">Sold out</span>
                                  <div class="loading__spinner hidden">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle></svg>
                                  </div>
                              </button>
                              <input type="hidden" name="product-id" value="${prod.id}">
                              <input type="hidden" name="section-id" value="CartDrawer">
                            </form>
                          </product-form>
                        </product-info>
                      </div>
                    </div>
                `;
                let newCell = document.createElement('div');
                newCell.className = 'carousel-cell';
                newCell.innerHTML = relatedCell;
                relFlkty.append(newCell);
              });

              // setTimeout(() => {
              //   relFlkty.destroy();
              // }, 100);
              
              // setTimeout(() => {
              //   relFlkty = new Flickity(div, options);
              // }, 100);

              // Custom navigation buttons
              parent.querySelector('.carousel-nav-button.previous').addEventListener('click', function() {
                relFlkty.previous();
              });
              
              parent.querySelector('.carousel-nav-button.next').addEventListener('click', function() {
                relFlkty.next();
              });

              // relFlkty.reloadCells();
              relFlkty.resize();

              window.addEventListener('resize', function() {
                // relFlkty.reloadCells();
                relFlkty.resize();
              });
            }
          });
      });
  }
}

  Shopify.formatMoney = function(cents, format) {
    if (typeof cents == 'string') {
    cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /{{\s*(\w+)\s*}}/;
    var formatString = (format || this.money_format);
    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');
        if (isNaN(number) || number == null) {
            return 0;
        }
        number = (number / 100.0).toFixed(precision);
        var parts = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents = parts[1] ? (decimal + parts[1]) : '';
        return dollars + cents;
    }
    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }
    return formatString.replace(placeholderRegex, value);
  };
  
  // Add to wishlist functionality
  // document.querySelectorAll('.wishlist-button').forEach(function(button) {
  //   button.addEventListener('click', function(e) {
  //     e.preventDefault();
  //     // Toggle active state for wishlist icon
  //     const icon = this.querySelector('.wishlist-icon');
  //     if (icon.getAttribute('fill') === 'none') {
  //       icon.setAttribute('fill', '#ff6b6b');
  //       icon.setAttribute('stroke', '#ff6b6b');
  //     } else {
  //       icon.setAttribute('fill', 'none');
  //       icon.setAttribute('stroke', '#fff');
  //     }
  //     // Here you would add actual wishlist functionality
  //   });
  // });

  // window.addEventListener('load', function() {
  //   // initShippingBar();
  //   initMiniCart();
  // });

  // star widget
  window.addEventListener('load', function() {
    const klaviyoStar = document.querySelector('.klaviyo-star-rating-widget');
    const mobileKlaviyoStar = document.querySelector('.klaviyo-star-rating-mobile');
    if (mobileKlaviyoStar) mobileKlaviyoStar.innerHTML = klaviyoStar.innerHTML;
  });
});